import type { MulticastFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/MulticastFormValues';
import type { UnicastFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/UnicastFormValues';
import type { FormikErrors } from 'formik';
import type { AppTranslations } from 'translations/translations';
import type { EntryPointValue } from './entryPoint';

export const validateEntryPoints = (
  values: UnicastFormValues | MulticastFormValues,
  msg: AppTranslations,
): FormikErrors<EntryPointValue>[] | undefined => {
  if (values.firstHopAlgorithm !== 'userDefined') {
    return undefined;
  }

  const entryPointsErrors: FormikErrors<EntryPointValue>[] = [];

  values.entryPoints.forEach((entryPoint, index) => {
    const entryPointsError: FormikErrors<EntryPointValue> = {
      host: undefined,
      iface: undefined,
    };

    if (!entryPoint.host) {
      entryPointsError.host =
        msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidValue;
    }

    if (!entryPoint.iface) {
      entryPointsError.iface =
        msg.canvasGraph.graphSidePanel.pathlookup.validation.invalidValue;
    }

    if (entryPointsError.host || entryPointsError.iface) {
      entryPointsErrors[index] = entryPointsError;
    }
  });

  if (entryPointsErrors.length > 0) {
    return entryPointsErrors;
  }
  return undefined;
};
